// Settings for Overlap Removal process. Usage of the properties depends on the algorithm.
export class OverlapRemovalSettings {
    constructor() {
        this.epsilon = 0.01;
        this.iterationsMax = 1000;
        this.stopOnMaxIterat = false;
        this.nodeSeparation = 4;
        this.randomizationSeed = 1;
        this.randomizationShift = 0.1;
    }
    // If true, the overlap iteration process stops after maxIterat iterations.
    get StopOnMaxIterat() {
        return this.stopOnMaxIterat;
    }
    set StopOnMaxIterat(value) {
        this.stopOnMaxIterat = value;
    }
    // Epsilon
    get Epsilon() {
        return this.epsilon;
    }
    set Epsilon(value) {
        this.epsilon = value;
    }
    // Number of maxIterat to be made. In each iteration overlap is partly removed.
    get IterationsMax() {
        return this.iterationsMax;
    }
    set IterationsMax(value) {
        this.iterationsMax = value;
    }
    // Minimal distance between nodes.
    get NodeSeparation() {
        return this.nodeSeparation;
    }
    set NodeSeparation(value) {
        this.nodeSeparation = value;
    }
    //
    get RandomizationSeed() {
        return this.randomizationSeed;
    }
    set RandomizationSeed(value) {
        this.randomizationSeed = value;
    }
    //
    get RandomizationShift() {
        return this.randomizationShift;
    }
    set RandomizationShift(value) {
        this.randomizationShift = value;
    }
    // Clones the settings together with the stressmajorization settings
    Clone() {
        const settings = new OverlapRemovalSettings();
        settings.Epsilon = this.Epsilon;
        settings.IterationsMax = this.IterationsMax;
        settings.StopOnMaxIterat = this.StopOnMaxIterat;
        settings.NodeSeparation = this.NodeSeparation;
        settings.RandomizationSeed = this.RandomizationSeed;
        settings.RandomizationShift = this.randomizationShift;
        return settings;
    }
}
//# sourceMappingURL=OverlapRemovalSettings.js.map